import {connect} from "react-redux";
import React from "react";


function StopViewerOverlay(props) {
  const {stop, index, StopMarker, markerStyle} = props;
  return(
    <StopMarker stop={stop} markerStyle={markerStyle}/>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(StopViewerOverlay)